import { render, staticRenderFns } from "./ButtonReport.vue?vue&type=template&id=6508e5c6&scoped=true&"
import script from "./ButtonReport.vue?vue&type=script&lang=js&"
export * from "./ButtonReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6508e5c6",
  null
  
)

export default component.exports